export default __webpack_public_path__ + "static/media/dashboardInactive.3af3450c.svg";